module.exports = __webpack_public_path__ + "img/featuredartist (2).f4c963e1.jpg";